import React, { MouseEvent } from "react";
import { CpIcon } from "@components";
import { a } from "kremling";

type CpPillProps = {
  text: string;
  onRemove?: () => void;
  className?: string;
  disabled?: boolean;
  teamMember?: boolean;
  viewOnly?: boolean;
};

export function CpPill(props: CpPillProps) {
  const { className, disabled, teamMember, onRemove, text, viewOnly } = props;

  return (
    <div
      className={a("cp-pill cp-ellipsis")
        .a(className)
        .m("cp-pr-8", !onRemove || viewOnly)
        .m(`cp-pill-green`, teamMember)
        .m("cp-pill--disabled", disabled)}
    >
      <span>{text}</span>
      {onRemove && !viewOnly && (
        <button
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
            onRemove();
          }}
          type="button"
          disabled={disabled}
        >
          <CpIcon
            name="close-small"
            fill={`${
              teamMember
                ? "var(--cp-color-pill-team-text)"
                : "var(--cps-color-pill-text)"
            }`}
          />
        </button>
      )}
    </div>
  );
}
